/**
 * This is an auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import type { ApiPartnership, ApiPartnershipInfo, EnumPartnershipType, InviteToPartnershipRequest } from '@Model';
import type { HttpActions, ListInfo, ListRequest, Result } from '@synqo/frontend-component-library';

/**
 * Calls the endpoints of PartnershipsController.
 */
export class PartnershipsRepository {
    constructor(private readonly http: HttpActions) {}

    /**
     * Calls POST /partnerships/invite
     */
    public inviteToPartnership(request: InviteToPartnershipRequest): Promise<Result<boolean>> {
        return this.http.post<Result<boolean>, InviteToPartnershipRequest>('/partnerships/invite', request);
    }

    /**
     * Calls POST /partnerships:query
     */
    public queryPartnerships(listRequest: ListRequest): Promise<Result<ListInfo<ApiPartnership>>> {
        return this.http.post<Result<ListInfo<ApiPartnership>>, ListRequest>('/partnerships:query', listRequest);
    }

    /**
     * Calls GET /partnerships/info
     */
    public getPartnershipInfo(customerAddressId: string, partnershipType: EnumPartnershipType): Promise<Result<ApiPartnershipInfo>> {
        const query = new URLSearchParams();
        query.set('customerAddressId', `${customerAddressId}`);
        query.set('partnershipType', `${partnershipType}`);

        return this.http.get<Result<ApiPartnershipInfo>>('/partnerships/info', query);
    }

    /**
     * Calls POST /partnerships/{partnershipId}:lock
     */
    public lockPartnership(partnershipId: string): Promise<Result<boolean>> {
        return this.http.post<Result<boolean>, undefined>(`/partnerships/${partnershipId}:lock`, undefined);
    }

    /**
     * Calls POST /partnerships/{partnershipId}:unlock
     */
    public unlockPartnership(partnershipId: string): Promise<Result<boolean>> {
        return this.http.post<Result<boolean>, undefined>(`/partnerships/${partnershipId}:unlock`, undefined);
    }
}
